import React from "react";
import styled from "styled-components";
import { useHistory } from "react-router";
import DescriptionCard from "./DescriptionCard";
import BackendInfo from "./BackendInfo";
import useAuthenticatedUser from "../../utils/hooks/useAuthenticatedUser";
import { getEnv } from "../../utils/helpers/text";
import { OwcButton } from "@one/react";

export const ModuleVersionStyled = styled.div`
  width: 100%;
  font-family: "Roboto", sans-serif;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #888;
  padding: 10px 0;
  margin-bottom: 44px;
  flex-grow: 1;
  top: ${(props) => (props.currentEnv ? "50px" : "20px")};
  height: ${(props) => (props.currentEnv ? "83%" : "93%")};
`;

export const InfoHeaderStyled = styled.div`
  display: flex;
  padding: 15px 0;
  justify-content: flex-start;
  width: 80%;
  max-width: 800px;
`;

const ModuleVersion = ({ redirectPath = "/" }) => {
  const history = useHistory();
  const user = useAuthenticatedUser();
  const currentEnv = getEnv();
  return (
    <ModuleVersionStyled data-testid="info-page" currentEnv={currentEnv}>
      <InfoHeaderStyled
      // style={currentEnv ? { marginTop: "230px" } : { marginTop: "160px" }}
      >
        {user && (
          <OwcButton
            data-testid="info-page-action-button-go-back"
            variant="secondary"
            onClick={() => {
              history?.goBack();
            }}
          >
            Go back
          </OwcButton>
        )}
      </InfoHeaderStyled>
      <DescriptionCard title="Frontend information" />
      <BackendInfo />
      <OwcButton
        data-testid="info-page-action-button-module-version"
        variant="primary"
        onClick={() => {
          history?.replace(redirectPath);
        }}
      >
        Go to home
      </OwcButton>
    </ModuleVersionStyled>
  );
};

export default ModuleVersion;
